import React, { ChangeEvent, FormEvent, useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { Button } from '@fashionnovateam/nova-ui-toolkit';
import TextInput from '../../../ReusableComponents/TextInput/TextInput';
import Alert from '../../../ReusableComponents/Alert/Alert';
import BookingTable from './BookingTable/BookingTable';
import { useSearchBookingByReference } from '../../../../Lib/Hooks/booking.hooks';

interface Props {
  open: boolean;
  onClose: () => void;
}

function QuickBookingSearchModal({ open, onClose }: Props) {
  const [reference, setReference] = useState<string>('');
  const searchBookingQuery = useSearchBookingByReference(reference);
  const search = (event: FormEvent) => {
    event.preventDefault();
    searchBookingQuery.refetch();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      data-testid="quick-booking-search-modal"
    >
      <DialogContent>
        <form
          onSubmit={search}
          className="flex flex-col gap-4 items-center"
          data-testid="booking-search-form"
        >
          <div className="flex gap-2 items-center">
            <TextInput
              label="Reference"
              value={reference}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                setReference(event.target.value);
              }}
            />
            <Button
              loading={searchBookingQuery.isLoading}
              disabled={reference.length === 0}
              type="submit"
              color="secondary"
            >
              Search
            </Button>
          </div>
          {searchBookingQuery.isError && (
            <Alert color="red" fullWidth>
              Error while searching for bookings
            </Alert>
          )}
          {searchBookingQuery.isFetched &&
            !searchBookingQuery.isError &&
            (searchBookingQuery.data && searchBookingQuery.data.count > 0 ? (
              <BookingTable bookings={searchBookingQuery.data.bookings} />
            ) : (
              <Alert color="blue" fullWidth>
                No bookings found
              </Alert>
            ))}
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default QuickBookingSearchModal;
